"use client";

import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Loader } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReservaTuSesion() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="py-16 px-4 bg-light-background">
      <div className={`max-w-lg mx-auto transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        <div className="text-center mb-8">
          <h2 className="text-3xl font-display font-semibold text-foreground-light mb-3">
            Reserva tu sesión
          </h2>
          <p className="text-base text-muted-foreground">Completa el formulario y me pondre en contacto contigo. Todas las solicitudes comienzan con una sesión de exploración gratuita.
El formato de acompañamiento se define juntos después.</p>
        </div>

        <FormProvider className="card shadow-medium p-8 bg-muted-light-background" formId="booking-form-sessions" sectionName="reserva-tu-sesion" defaultValues={{
        name: "",
        email: "",
        sessionType: ""
      }} validationRules={{
        name: {
          required: true,
          minLength: 2,
          maxLength: 50
        },
        email: {
          required: true,
          pattern: "email"
        },
        sessionType: {
          required: true
        }
      }} submitText="Enviar solicitud" successMessage="¡Gracias! Nos pondremos en contacto contigo pronto." errorMessage="Error al enviar. Por favor, inténtalo de nuevo.">
          <BookingForm />
        </FormProvider>
      </div>
    </section>;
}
function BookingForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="text-center space-y-4">
        <div className="p-6 bg-primary-light border border-primary/20 rounded-lg">
          <p className="text-primary-dark font-medium">{successMessage}</p>
        </div>
        <Button onClick={resetForm} variant="outline" className="hover-lift">
          Enviar otra solicitud
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit}>
      <div className="space-y-6">
        <FormField control={control} name="name" rules={{
        required: "El nombre es obligatorio",
        minLength: {
          value: 2,
          message: "Mínimo 2 caracteres"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Nombre completo</FormLabel>
              <FormControl>
                <Input placeholder="Tu nombre" className="transition-all duration-[var(--duration-medium)] focus-ring" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        required: "El email es obligatorio",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Email inválido"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Email</FormLabel>
              <FormControl>
                <Input type="email" placeholder="tu@ejemplo.com" className="transition-all duration-[var(--duration-medium)] focus-ring" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="sessionType" rules={{
        required: "Por favor selecciona un tipo de sesión"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>¿Qué te gustaría explorar?</FormLabel>
              <Select onValueChange={field.onChange} value={field.value}>
                <FormControl>
                  <SelectTrigger className="w-full transition-all duration-[var(--duration-medium)] focus-ring">Sesión de exploración gratuita</SelectTrigger>
                </FormControl>
                <SelectContent>
                  <SelectItem value="individual">Sesión individual</SelectItem>
                  <SelectItem value="pack-3">Pack de 3 sesiones</SelectItem>
                  <SelectItem value="pack-6">Pack de 6 sesiones</SelectItem>
                  <SelectItem value="mensual">Acompañamiento mensual</SelectItem>
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>} />

        {submitError && <div className="p-4 bg-accent-light border border-accent/30 rounded-lg">
            <p className="text-accent-dark text-sm">{submitError}</p>
          </div>}

        <Button type="submit" disabled={isSubmitting} className="btn-primary w-full transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
          {isSubmitting ? <>
              <Loader className="animate-spin mr-2 size-4" />
              Enviando...
            </> : "Enviar solicitud"}
        </Button>
      </div>
    </Form>;
}